import baseApi from '../../lib/baseApi';
import {
  SpiritualServiceDto,
  MemberServiceTypeDto,
  CreateMemberServicePayload,
  UpdateMemberServicePayload,
  ServicesPolicyResponseAll,
  ServicePolicyResponseSingle
} from "../../types/profiles/memberServicesTypes";


const BASE_PATH = "/profiles/members";

// Catalog
export const fetchServicesCatalogApi = async (): Promise<SpiritualServiceDto[]> => {
  const { data } = await baseApi.get(`${BASE_PATH}/services-catalog/`);
  return data;
};

// My services (list)
export const fetchMyServicesApi = async (): Promise<MemberServiceTypeDto[]> => {
  const { data } = await baseApi.get(`${BASE_PATH}/my-services/`);
  return data;
};

// Create (multipart) -------------------------------------------------------------------------
export const createMyServiceApi = async (
  payload: CreateMemberServicePayload
): Promise<MemberServiceTypeDto> => {
  const form = new FormData();
  form.append("service_id", String(payload.service_id));
  if (payload.history) form.append("history", payload.history);
  if (payload.document) form.append("document", payload.document);

  if (payload.credential_issuer) form.append("credential_issuer", payload.credential_issuer);
  if (payload.credential_number) form.append("credential_number", payload.credential_number);
  if (payload.credential_url) form.append("credential_url", payload.credential_url);
  if (payload.issued_at) form.append("issued_at", payload.issued_at);
  if (payload.expires_at) form.append("expires_at", payload.expires_at);

  const { data } = await baseApi.post(`${BASE_PATH}/services/`, form);
  return data;
};

// Update (multipart; partial) ----------------------------------------------------------------
export const updateMyServiceApi = async (
  payload: UpdateMemberServicePayload
): Promise<MemberServiceTypeDto> => {
  const { id, remove_document, ...rest } = payload;
  const form = new FormData();

  // text fields (only if provided)
  if (rest.history !== undefined) form.append("history", rest.history ?? ""); // empty string -> clear
  if (rest.credential_issuer !== undefined) form.append("credential_issuer", rest.credential_issuer ?? "");
  if (rest.credential_number !== undefined) form.append("credential_number", rest.credential_number ?? "");
  if (rest.credential_url !== undefined) form.append("credential_url", rest.credential_url ?? "");

  // dates (send empty to nullify)
  if (rest.issued_at !== undefined) form.append("issued_at", rest.issued_at ?? "");
  if (rest.expires_at !== undefined) form.append("expires_at", rest.expires_at ?? "");

  // file remove flag
  if (remove_document) form.append("remove_document", "true"); // backend will delete existing file

  // new file (only if a File provided)
  if (rest.document !== undefined && rest.document !== null) {
    form.append("document", rest.document); // replacing file
  }

  // PATCH multipart endpoint
  const { data } = await baseApi.patch(`${BASE_PATH}/services/${id}/`, form);
  return data;
};


// Delete (unlink + soft delete if no other owners) ----------------------------------------------
export const deleteMyServiceApi = async (id: number): Promise<void> => {
  await baseApi.delete(`${BASE_PATH}/services/${id}/`);
};


// Policy (Multi-path) APIs ----------------------------------------------------------------------
export const fetchServicesPolicyApi = async (): Promise<ServicesPolicyResponseAll> => {
  const { data } = await baseApi.get(`${BASE_PATH}/services-policy/`);
  return data;
};

export const fetchServicePolicyApi = async (
  serviceCode: string
): Promise<ServicePolicyResponseSingle> => {
  const { data } = await baseApi.get(`${BASE_PATH}/services-policy/`, {
    params: { service: serviceCode },
  });
  return data;
};